import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalComponent } from './modal.component';

@Injectable()
export class ModalService {
  private modal: ModalComponent;

  public registerModal(modal: ModalComponent): void {
    if (this.modal) {
      throw new Error(
        'You can only register one modal component to this service.'
      );
    }
    this.modal = modal;
  }

  public open(component: any, inputs?: any): Subject<any> {
    if (!this.modal) {
      throw new Error("You can't open a modal before registering one.");
    }
    return this.modal.open(component, inputs);
  }

  public close(data?: any): any {
    this.modal.close(data);
    return data;
  }
}
